<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span class="d-flex justify-content-between align-items-center m-3">
        <span class="col-auto d-flex gap-2">
          <h2 class="mb-0">Specials</h2>
          <jni-spinner *ngIf="showLoader"></jni-spinner>
        </span>
        <span class="d-flex gap-2 customizefilter-btn">
          <p-button
            label="Export Excel"
            variant="outlined"
            icon="pi pi-cloud-upload"
            severity="secondary"
            (click)="exportExcel()"
            class="fullwdth secondary-btn" />
        </span>
      </span>

      <div class="col-lg-12">
        <p-table
          #dt
          stripedRows
          [value]="specialsListings"
          [rowHover]="true"
          [rows]="50"
          [showCurrentPageReport]="true"
          [scrollable]="true"
          scrollHeight="calc(100vh - 265px)"
          [size]="'small'"
          [resizableColumns]="true"
          [rowsPerPageOptions]="[10, 20, 50, 100, 500, 1000]"
          [paginator]="true"
          paginatorStyleClass="paginator-table"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [filterDelay]="0"
          styleClass="table-listing"
          [lazy]="true"
          (onLazyLoad)="getAllSpecialsListingData($event)"
          [totalRecords]="totalRecords">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th class="max-width-6">Vendor Account</th>
              <th class="max-width-10">Vendor Name</th>
              <th class="max-width-10">Eligible Product</th>
              <th class="max-width-15">Description</th>
              <th class="max-width-6">Pricing</th>
              <th class="max-width-6">Effective Date</th>
              <th class="max-width-6">Expiration Date</th>
              <th class="max-width-8">Vendor Contact</th>
            </tr>
            <tr>
              <th class="max-width-6">
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="vendorAccountNumber"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"></p-columnFilter>
                </div>
              </th>
              <th class="max-width-10"></th>
              <th class="max-width-10">
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="eligibleProduct"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"></p-columnFilter>
                </div>
              </th>
              <th class="max-width-15"></th>
              <th class="max-width-6">
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="pricing"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"></p-columnFilter>
                </div>
              </th>
              <th class="max-width-6"></th>
              <th class="max-width-6"></th>
              <th class="max-width-8">
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="vendorContact"
                    (input)="onFilterInput($event)"
                    [showMenu]="false"></p-columnFilter>
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-special let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row"
              [pSelectableRow]="special"
              [pSelectableRowIndex]="rowIndex">
              <td
                class="max-width-6"
                (click)="getCurrentVendor(special.vendorAccountNumber)">
                <a>{{ special.vendorAccountNumber }}</a>
              </td>
              <td class="max-width-10">
                {{ special.vendorName }}
              </td>
              <td class="max-width-10">
                {{ special.eligibleProduct }}
              </td>
              <td class="max-width-15">
                {{ special.description }}
              </td>
              <td class="max-width-6">
                {{ special.pricing }}
              </td>
              <td class="max-width-6">
                {{ formatDate(special.effectiveDate) }}
              </td>
              <td class="max-width-6">
                {{ formatDate(special.expirationDate) }}
              </td>
              <td class="max-width-8">
                {{ special.vendorContact }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No specials found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>

<jni-modal-stacker
  *ngIf="vendorDisplayModal"
  [displayModal]="vendorDisplayModal"
  (closeEvent)="closeModal()">
  <h1 class="panelHeading">Vendor Summary</h1>
  <div class="panelBody">
    <jni-vendor-summary
      [vendorIdFromModal]="vendorAccountNumber"
      (scrollHiddenStatus)="addScollHiddenClass()"
      (emitcloseVendorModalStacker)="closeModal()"></jni-vendor-summary>
  </div>
</jni-modal-stacker>
